import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getStorage } from 'firebase/storage';


const firebaseConfig = {
    apiKey: "AIzaSyDRWCNx7XYWKH2zO_gyy3BEC2YRxxPFWzg",
    authDomain: "beanbonusweb.firebaseapp.com",
    projectId: "beanbonusweb",
    storageBucket: "beanbonusweb.firebasestorage.app",
    messagingSenderId: "279388401560",
    appId: "1:279388401560:web:8b8c8bdc8515eba02a05ed",
    measurementId: "G-7SVJQSZDVB"
}

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const functions = getFunctions(app)
const storage = getStorage(app)

export { app, db, functions, storage };
